import { Editor } from '@tiptap/core';
import { Rect } from '@popperjs/core';
import { Placement } from 'tippy.js';
import { getParentWithScroll } from '../../../../../shared/lib/getParentWithScroll';
import {
  EDITOR_CONTAINER_ID,
  LEFT_SIDEBAR_ID,
} from '../../../../../features/editor-left-sidebar/config';

type OffsetProps = {
  popper: Rect;
  reference: Rect;
  placement: Placement;
};

export const getNodeByType = (editor: Editor, nodeType: string) => {
  const { from, to } = editor.state.selection;
  let node = null;
  let position = null;

  editor.state.doc.nodesBetween(from, to, (n, pos) => {
    if (n.type.name === nodeType) {
      node = n;
      position = pos;
    }
  });

  return { node, position };
};

export const calculateBubbleMenuOffset = (
  editor: Editor,
  nodeType: string,
  { popper, reference }: OffsetProps
): [number, number] => {
  if (!editor) return [0, 0];

  const { position } = getNodeByType(editor, nodeType);
  if (position === null) return [0, 0];

  const domNode = editor.view.nodeDOM(position);
  const rect = (domNode as HTMLElement)?.getBoundingClientRect();
  if (!rect) return [0, 0];

  const leftSidebar = document.getElementById(LEFT_SIDEBAR_ID);
  const editorContainer = document.getElementById(EDITOR_CONTAINER_ID);
  const sidebarRightEdge = leftSidebar?.getBoundingClientRect().right || 0;
  const editorLeftEdge = editorContainer?.getBoundingClientRect().left || 0;
  const additionalSpace = editorLeftEdge - sidebarRightEdge;

  // Calculate the center of the block
  const blockCenter = rect.width / 2;

  // Get the width of the BubbleMenu
  const bubbleMenuWidthCenter = popper.width / 2;

  // Calculate the offset to place the BubbleMenu in the center of the block
  const offsetCenter = blockCenter - bubbleMenuWidthCenter;
  const offset =
    rect.left +
    offsetCenter -
    reference.x -
    (leftSidebar?.clientWidth ?? 0) -
    additionalSpace;

  const scrolledParent = getParentWithScroll(editor.view.dom as HTMLElement);
  const scrollTop = scrolledParent?.scrollTop ?? 0;
  const offsetTop = reference.y - (rect.top + scrollTop - popper.height - 10);

  return [offset, offsetTop];
};

export const handleEmojiInputClick = (
  event: React.PointerEvent<HTMLDivElement>
) => {
  if ((event.target as HTMLElement).tagName === 'INPUT') {
    event.stopPropagation();
  }
};
